import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

/**
 * Solution — src/Design/industries/industry-*.html, SECTION 3.
 * Exact 50/50 split: photo on the LEFT running to the window edge, text on
 * the right. One offer, not a tab set — the shared offer name, fit line,
 * a single timeline figure and a 4-feature grid.
 */
const Solution = ({
  eyebrow,
  heading,
  offerName,
  fit,
  timelineValue,
  timelineLabel,
  features = [],
  linkLabel,
  linkHref,
  image,
  imageAlt,
}) => (
  <section className="isolution">
    <div className="isolution__media">
      {image && <GatsbyImage image={image} alt={imageAlt || ""} loading="lazy" className="isolution__photo" />}
    </div>
    <div className="isolution__inner">
      <div className="isolution__copy">
        <p className="isolution__eyebrow">{eyebrow}</p>
        <h2 className="isolution__heading">{heading}</h2>
        <h3 className="isolution__offer">{offerName}</h3>
        <p className="isolution__fit">{fit}</p>

        <div className="isolution__timeline">
          <span className="isolution__timeline-num">{timelineValue}</span>
          <span className="isolution__timeline-lbl">{timelineLabel}</span>
        </div>

        <div className="isolution__features">
          {features.map(f => (
            <div className="isolution__feature" key={f.title}>
              <span
                className="isolution__feature-icon"
                aria-hidden="true"
                // width/height/fill/stroke are set directly on the <svg>
                // itself (not just in CSS): an icon injected this way can
                // never render oversized or solid black even if the
                // stylesheet fails to reach the page for any reason.
                dangerouslySetInnerHTML={{
                  __html: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${f.iconPath}</svg>`,
                }}
              />
              <strong className="isolution__feature-title">{f.title}</strong>
              <span className="isolution__feature-detail">{f.detail}</span>
            </div>
          ))}
        </div>

        <a className="isolution__link" href={linkHref}>
          {linkLabel}
        </a>
      </div>
    </div>
  </section>
)

export default Solution
